

  import scoringMethodologyCategories from '@/apollo/queries/scoring-methodology/scoringMethodologyCategories'
  import pageMeta from '~/mixins/pageMeta.js';

  export default {
    mixins: [pageMeta],

    data() {
      return {
        pageData: Object,
        loading: 0,
        isContentAnchorWidgetActive: false,
        pageRendered: false,
      };
    },


    computed: {

      titleAnchorData() {
        const list1  = Array({"paragraphIndex": "glossary-section","TitleText": this.pageData?.GlossarySection?.Title})
        const list2  = this.pageData?.TextModule.map(function(item, index) {
          item.paragraphIndex = index
          return item
        }).filter((item) => item.TitleText )
        let list = list1
        list = list1.concat(list2)
        return list
      },

    },

    watch: {
      pageRendered(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setOnScrollListener()
        }
      }
    },
    created() {
    },
    updated() {
      this.pageRendered = true
    },
    mounted() {
      this.jumpTo(this.$route.hash)
    },
    methods: {
      setOnScrollListener() {

        const _vue = this // << here
        this.$nextTick(()=>{

          let prevScrollpos = window.pageYOffset;
          const titleElements = document.querySelectorAll(".title.font-h3")
          window.onscroll = function() {
            const clientWidth = document.body.clientWidth
            const currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) { // up

              if ( currentScrollPos < 200 ){ // almost top
                _vue.showContentAnchorWidget(false)
              }

            } else { // down

              if(clientWidth > 768) {

                if ( currentScrollPos > 200 && currentScrollPos < 500 ){ //  leaving top
                  _vue.showContentAnchorWidget(true)
                }

                if( checkVisible(titleElements[1]) ) {
                  _vue.showContentAnchorWidget(false)
                }
              }
              if(clientWidth > 1600) {
                //
              }

            }
            prevScrollpos = currentScrollPos;

          }
        })

        function checkVisible(elm, threshold, mode) {
          threshold = threshold || 0;
          mode = mode || 'visible';

          if(elm) {
            const rect = elm.getBoundingClientRect();
            const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            const above = rect.bottom - threshold < 0;
            const below = rect.top - viewHeight + threshold >= 0;

            return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
          }
          return false
        }
      },
      openAnchorWidget() {
          this.showContentAnchorWidget(true)
      },
      closeAnchorWidget() {
          this.showContentAnchorWidget(false)
      },
      showContentAnchorWidget(boolean) {
        this.isContentAnchorWidgetActive = boolean
      },
      jumpTo(theHash) {
        if (!theHash) return

        this.$nextTick(() => {

            const el = document.querySelector(theHash)
            if(el) {

              const targetElement = el
              const navbar = document.querySelector('.nav-bar');
              const height = navbar.offsetHeight;
              let mobileExtra = 0
              if (navigator.userAgent.toLowerCase().match(/mobile/i)) { mobileExtra = 80}
              const scrollTopHeight = (targetElement.offsetTop) - (height + mobileExtra - 10 )

              window.scrollTo({
                top: scrollTopHeight ,
                behavior: "smooth"
              });
            }

          })
      }
    },

    apollo: {
      $loadingKey: "loading",
      pageData: {
        prefetch: true,
        query: scoringMethodologyCategories,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale), slug: this.$route.params.slug };
        },
        update(data) {
          const normalized = this.$normalizeStrapi(data.scoringMethodologyCategories);

          if (normalized && normalized.length > 0 && normalized[0]) {
            return normalized[0]
          }

          return null;
        },
      },
    },

  }
